import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface RoundedCheckIconProps extends IconProps {
  backgroundColor?: string;
}

const RoundedCheckIcon = ({ size, variant, className, backgroundColor }: RoundedCheckIconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="35" cy="35" r="35" fill={backgroundColor ?? '#11E8C2'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.0972 23.7029C52.0345 24.6402 52.0345 26.1598 51.0972 27.0971L31.8973 46.2971C30.96 47.2343 29.4404 47.2343 28.5031 46.2971L18.9031 36.6971C17.9659 35.7598 17.9659 34.2402 18.9031 33.3029C19.8404 32.3657 21.36 32.3657 22.2973 33.3029L30.2002 41.2059L47.7031 23.7029C48.6404 22.7657 50.16 22.7657 51.0972 23.7029Z"
      fill="white"
    />
  </svg>
);

export default RoundedCheckIcon;
